module.exports = __webpack_public_path__ + "static/img/fzlc.c17f321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/fzlc.png
// module id = JeNV
// module chunks = 3